import React, { Component } from 'react';
import { connect } from 'react-redux';
import { LocalForm, Control, Errors } from 'react-redux-form';
import { Button, Modal, FormGroup, FormControl } from 'react-bootstrap';

import Select from '../common/form/elements/select';
import { getOutlets, setDefaultStore } from '../../actions/outlet';

const message = [
  <span>
    Please select a default store to allocate to your
    <strong> ignite </strong>
    account
  </span>,
  `
  Your default store will be the store automatically selected when
  placing an order, however you will have the opportunity to change
  the delivery store when starting your order
  `,
  <span>
    You can change your default store at any time in the
    <strong> Store Summary </strong>
    area of your account
  </span>
];

class DefaultStorePopup extends Component {
  handleSubmit = ({ defaultStoreId }) => {
    this.props.dispatch(setDefaultStore(defaultStoreId));
  }

  componentWillMount() {
    this.props.dispatch(getOutlets(false));
  }

  componentDidMount() {
    const { popupActive } = this.props;
    popupActive(true);
  }

  componentWillUnmount() {
    const { popupActive } = this.props;
    popupActive(false);
  }
  
  render() {
    const { submitting, fetching, outlets } = this.props;

    if (!outlets.length) return null;

    return (
      <div className="modal-container">
        <Modal show container={this} aria-labelledby="default-store-title">
          <Modal.Header>
            <Modal.Title id="default-store-title">Choose your default store</Modal.Title>
          </Modal.Header>
          <LocalForm
            validators={{
              defaultStoreId: { required: val => val && val !== "" }
            }}
            onSubmit={this.handleSubmit}
          >
            <Modal.Body>
              {message.map((paragraph, index) => (
                <p className="text-left" key={index}>
                  {paragraph}
                </p>
              ))}

              <FormGroup>
                <Control.select
                  model=".defaultStoreId"
                  componentClass="select"
                  component={FormControl}
                >
                  <option value="">
                    Select a store
                  </option>
                  {outlets.map(({ id, title }) => (
                    <option key={id} value={id}>
                      {title}
                    </option>
                  ))}
                </Control.select>
                <Errors
                  model=".defaultStoreId"
                  messages={{ required: "is required" }}
                  wrapper={({ children }) =>
                    <div className="errors text-left">{children}</div>
                  }
                  show={{ touched: true, focus: false }}
                />
              </FormGroup>
            </Modal.Body>
            <Modal.Footer>
              <Control.custom
                model="local"
                component={Button}
                bsStyle="primary"
                type="submit"
                className="red-ghost-btn float-right"
                mapProps={({ fieldValue: { valid }}) => ({
                  disabled: !valid || fetching
                })}
              >
                {submitting ? 'Saving' : 'Save'}
              </Control.custom>
            </Modal.Footer>
          </LocalForm>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = ({ stores: { stores, fetching, defaultStore } }) => ({
  outlets: stores.map(({ id, attributes }) => ({
    id,
    title: `${attributes.name} ${attributes['customer-number']}`
  })),
  fetching: fetching || defaultStore.state === 'pending',
  submitting: defaultStore.state === 'pending'
});

export default connect(mapStateToProps)(DefaultStorePopup);



// WEBPACK FOOTER //
// ./src/components/your-store/default-store-popup.jsx